import Link from 'next/link'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import { useState, useEffect } from 'react'

import { useHits } from 'react-instantsearch'

function EventItem({ event }) {
  const { title, permalink } = event || {}

  const expired = moment(event.end).isBefore(moment(), 'day')

  return (
    <Link
      href={permalink}
      className={`rbc-event-link ${expired ? 'expired' : 'active'} text-14 hover:underline`}>
      {title}
    </Link>
  )
}

export default function EventsCalendar() {
  const { items } = useHits()
  const [view, setView] = useState('month')

  useEffect(() => {
    const checkMobile = () => {
      const isMobile = window.innerWidth < 768
      setView(isMobile ? 'agenda' : 'month')
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const filteredItems = items.filter((item) => {
    const hasStartDate = !!item?.event_date?.start_date_ymd
    const hasEndDate = !!(item?.event_date?.end_date_ymd || item?.event_date?.start_date_ymd)

    return hasStartDate && hasEndDate
  })

  const events = filteredItems
    .map((item, index) => {
      try {
        const startDate = parseInt(item?.event_date?.start_date_ymd)
        const endDate = parseInt(item?.event_date?.end_date_ymd) || startDate

        // Get time values if they exist
        const startTime = item?.event_date?.start_time || null
        const endTime = item?.event_date?.end_time || null

        // Parse start date - try multiple formats
        let start = moment(startDate, 'YYYYMMDD').toDate()

        // Apply time if exists
        if (startTime && !isNaN(start.getTime())) {
          const [hours, minutes] = startTime.split(':')
          start = moment(start).hour(parseInt(hours, 10)).minute(parseInt(minutes, 10)).toDate()
        }

        // Parse end date
        let end = moment(endDate, 'YYYYMMDD').toDate()

        // Apply time if exists
        if (endTime && !isNaN(end.getTime())) {
          const [hours, minutes] = endTime.split(':')
          end = moment(end).hour(parseInt(hours, 10)).minute(parseInt(minutes, 10)).toDate()
        } else if (!startTime && !endTime && !isNaN(end.getTime())) {
          // All day event - set end to end of day
          end = moment(end).endOf('day').toDate()
        }

        // Validate dates
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
          return null
        }

        const timezone = item?.timezone || 'GMT'

        const prettyStartTime = startTime ? moment(start).format('h:mm A') : null

        let title = item?.post_title

        // Include timezone in title if not GMT (weekly, daily, agenda views)
        if (view !== 'month') {
          title =
            timezone && timezone !== 'GMT'
              ? `${item?.post_title} (${prettyStartTime} ${timezone})`
              : item?.post_title
        }

        return {
          title,
          permalink: item?.permalink,
          start,
          end,
          allDay: !startTime && !endTime,
        }
      } catch (error) {
        console.error('Error parsing event:', item?.post_title, error)
        return null
      }
    })
    .filter(Boolean)

  const localizer = momentLocalizer(moment)

  return (
    <div className="container">
      <div className="component">
        <Calendar
          localizer={localizer}
          events={events}
          view={view}
          onView={setView}
          components={{
            event: EventItem,
          }}
          views={{
            month: true,
            week: true,
            agenda: true,
            day: true,
          }}
          messages={{
            previous: 'Previous',
          }}
          step={30}
          timeslots={2}
        />
      </div>
    </div>
  )
}
